export class DistanceCoordinate {
  constructor(public lat: number, public lng: number) {}
}

export enum CardinalDirection {
  north,
  west,
  south,
  east
}

export class BoundingBox {
  constructor(public nwCoordinate: DistanceCoordinate, public seCoordinate: DistanceCoordinate) { }
}